export enum Role {
    ADMIN,
    USER,
    DIRECTOR
  }